import {RESET_PASSWORD, SET_LOADING_RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR,
    REGISTRATION, SET_LOADING_REGISTRATION, REGISTRATION_SUCCESS, REGISTRATION_ERROR,
    LOGIN, SET_LOADING_LOGIN, LOGIN_SUCCESS, LOGIN_ERROR } from '../actions/AuthActions';

const INITIAL_STATE = {
    loadingResetPassword: false, 
    loadingRegistration: false,
    loadingLogin: false, 
};

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case SET_LOADING_REGISTRATION:
            return {...state, loadingRegistration: true} 
        case REGISTRATION:
            return {...state}
        case REGISTRATION_SUCCESS:
            return {...state, loadingRegistration: false}
        case REGISTRATION_ERROR:
            return {...state, loadingRegistration: false}

        case SET_LOADING_LOGIN:
            return {...state, loadingLogin: true}
        case LOGIN:
            return {...state}
        case LOGIN_SUCCESS:
            return {...state, loadingLogin: false}
        case LOGIN_ERROR:
            return {...state, loadingLogin: false}

        case SET_LOADING_RESET_PASSWORD:
            return {...state, loadingResetPassword: true}
        case RESET_PASSWORD:
            return {...state}
        case RESET_PASSWORD_SUCCESS:
            return {...state, loadingResetPassword: false}
        case RESET_PASSWORD_ERROR:
            return {...state, loadingResetPassword: false}
        default:
            return state;
    }
}
